export default __webpack_public_path__ + "static/media/a041-1.5f115067.png";